import { put, select, call } from 'redux-saga/effects';

import * as actions from '../../actions';

import moveQuestion from './moveQuestion';
import updateDecisionFramework from '../updateDecisionFramework/updateDecisionFramework';

export default function*(action) {
  const surveysState = yield select(state => state.surveys);
  const authState = yield select(state => state.auth);

  let newState = { ...surveysState };

  if (surveysState.activeFlow && !surveysState.activeFlow.flows) {
    const newSurveyStateActiveFlow = {
      question: { ...surveysState.activeFlow }
    };
    action.api(
      'updateQuestion',
      newSurveyStateActiveFlow,
      undefined,
      undefined,
      authState
    );

    if (
      surveysState.activeFlow.matrix &&
      surveysState.activeFlow.matrix.decisionFrameworkType
    ) {
      const {
        surveyWithUpdatedFramework,
        updateRequest
      } = updateDecisionFramework(surveysState.survey, surveysState.activeFlow);
      if (surveyWithUpdatedFramework) {
        newState = {
          ...newState,
          survey: surveyWithUpdatedFramework
        };
        if (updateRequest) {
          yield call(
            action.api,
            updateRequest.api,
            {
              variables: updateRequest.variables
            },
            undefined,
            undefined,
            authState
          );
        }
      }
    }
  }

  newState = moveQuestion(
    newState,
    action.dropzone,
    action.sourceSetIndex,
    action.sourceQuestionindex,
    action.destinationSetIndex,
    action.destionationQuestionindex,
    action.destinationPosition,
    action.destinationQuestionId
  );

  if (!newState) {
    return;
  }

  yield put({ type: actions.SET_NEW_STATE, newState: newState.newState });

  // Update survey
  const surveyUpdateContent = {
    survey: newState.newState.survey.id,
    content: newState.newState.survey.content
  };
  action.api(
    'updateSurvey',
    { variables: surveyUpdateContent },
    undefined,
    undefined,
    authState
  );

  // If flow jump from other question after this action is changed, update it
  if (
    newState.changedFlowsRemovedJumpsToUpdate &&
    newState.changedFlowsRemovedJumpsToUpdate.length
  ) {
    newState.changedFlowsRemovedJumpsToUpdate.forEach(q => {
      if (q && !q.flows) {
        action.api(
          'updateQuestion',
          { question: { ...q } },
          undefined,
          undefined,
          authState
        );
      }
    });
  }
}
